import React, {useState} from 'react';
import styled from 'styled-components/native';
import { View, Text, Pressable } from 'react-native';
import { Link } from 'app/src/utils/routing';
import { elLightGray } from '../../styles/colors';
import { useLocation } from 'react-router-dom';
import {
  LinkContainer,
  LinkSpace
} from 'app/src/elements';
import Modal from '../../elements/Modal';
import NewSalesperson from './new';
import EditSalesperson from './edit';

const NavbarContainer = styled(View)`
  display: flex;
  flex-direction: row;

  flex: 0.25;
  align-items: center;
  height: 5px;
  background-color: ${elLightGray};
  padding: 15px;
  padding-left: 50px;
`;

const BoldLinkText = styled(Text)`
  font-weight: bold;
`;

const SubNav = ({salesperson, refetch}) => {
  const [showAddSalespersonModal, setShowAddSalespersonModal] = useState(false);
  const [showEditSalespersonModal, setShowEditSalespersonModal] = useState(false);
  const loc = useLocation();
  return (
    <NavbarContainer>
      {getLinks()}
    </NavbarContainer>
  )

  function getLinks() {
    if(loc.pathname === '/commissions-and-salespeople') {
      return (
        <View>
          <Pressable
            onPress={() => setShowAddSalespersonModal(true)}
          >
            <Text>+ Add Salesperson</Text>
          </Pressable>
          {showAddSalespersonModal &&
            <Modal
              showModal={showAddSalespersonModal}
              setShowModal={setShowAddSalespersonModal}
              modalType={'Add Salesperson'}
              salespersonId={salesperson?.id}
            >
              <NewSalesperson
                setShowModal={setShowAddSalespersonModal}
                refetch={refetch}
              />
            </Modal>
          }
        </View>
      )
    }else if(loc.pathname === '/salespeople/new') {
      return (
        <Link to={`/salespeople`}>
          <Text>Salespeople</Text>
        </Link>
      )
    }else {
      return (
        <LinkContainer>
          <BoldLinkText>{salesperson?.name}</BoldLinkText>
          <LinkSpace />
          <Pressable
            onPress={() => {
              setShowEditSalespersonModal(true)
            }}
          >
            <Text>
              Edit
            </Text>
          </Pressable>
          {showEditSalespersonModal &&
            <Modal
              refetch={refetch}
              showModal={showEditSalespersonModal}
              setShowModal={setShowEditSalespersonModal}
              modalType={'Edit Salesperson'}
              objectName={salesperson.name}
            >
              <EditSalesperson
                setShowModal={setShowEditSalespersonModal}
                refetch={refetch}
                salespersonDetails={salesperson}
              />
            </Modal>
          }
        </LinkContainer>
      )
    }
  }
}

export default SubNav